import React, { useState } from 'react'
import * as PropTypes from 'prop-types'
import styled, { ThemeProvider } from 'styled-components'
import MainNav from './main-nav'
import SecondaryNav from './secondary-nav'

export const headerAnimationDuration = 200
const TRANSITION = 'all 0.2s ease-in-out'

const Header = ({ kind }) => {
  const [locationMenuActive, setLocationMenuActive] = useState(false)
  return (
    <ThemeProvider theme={{ kind, locationMenuActive, transition: TRANSITION }}>
      <StyledHeader>
        <MainNav />
        <SecondaryNav setLocationMenuActive={setLocationMenuActive} />
        <PagePadding />
      </StyledHeader>
    </ThemeProvider>
  )
}

Header.propTypes = {
  kind: PropTypes.oneOf(['default', 'white', 'light']),
}

Header.defaultProps = {
  kind: 'default',
}

const StyledHeader = styled.header`
  display: flex;
  flex-direction: column-reverse;
  position: relative;

  @media (min-width: 900px) {
    display: block;
  }
`

const PagePadding = styled.div`
  background-color: ${props => (props.theme.kind === 'light' ? props.theme.color.n10 : '#fff')};
  display: none;

  @media (min-width: 900px) {
    display: ${props => (props.theme.kind === 'default' ? 'none' : 'block')};
    height: 75px;
  }
`

export default Header
